var map = {
	"./en/card_4_1.png": "mAeD",
	"./es/card_4_1.png": "35ng",
	"./pt/card_4_1.png": "YuDL"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "eXLs";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/.*\/card_4_1\.png$
// module id = eXLs
// module chunks = 0